/* Price comparisons always use the same variant and a fixed pre-sale baseline. */
(function (scope) {
 'use strict';
 function quote(variants, phase) {
  const key=phase==='before'?'sale':'price';
  const variant=variants.reduce((best,v)=>!best||v[key]<best[key]?v:best,null);
  if(!variant)return null;
  const current=variant[key],reference=variant.referencePrice;
  const saving=Number.isFinite(reference)?Math.max(0,reference-current):0;
  return {current,reference,saving,percent:reference>0?Math.floor(saving*100/reference):0,
   discounted:phase!=='ended'&&saving>0,range:variants.some(v=>v[key]!==current),
   mixed:variants.some(v=>v[key]!==current||v.referencePrice!==reference),variantId:variant.id};
 }
 if(typeof module!=='undefined'&&module.exports)module.exports={quote};
 else scope.SalePricing={quote};
})(typeof window!=='undefined'?window:this);
